import { Copy, SendHorizontal, X } from "lucide-react";
import React, { useEffect, useState } from "react";

export default function InviteModal({
  isOpen,
  onClose,
  onSend,
  copyLink,
  inviteLink = copyLink,
}) {
  const [recipients, setRecipients] = useState("");
  const [names, setNames] = useState("");
  const [message, setMessage] = useState("");
  const [tooltipText, setTooltipText] = useState("Click to copy to clipboard");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setRecipients("");
      setNames("");
      setMessage("");
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;


  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Click to copy to clipboard"), 2000);
    if (typeof copyLink === "function") copyLink(inviteLink);
  };

  const handleSend = async () => {
    if (typeof onSend === "function") {
      setLoading(true);
      const result = await onSend({ recipients, names, message });
      if (result?.status === "OK") {
        setLoading(false);
        onClose(); // close here
      } else {
        setLoading(false); // keep modal open to show error
      }
    }
  };

  return (
    <div
      className="fixed inset-0 z-[1041] flex items-center justify-center bg-black bg-opacity-50"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-[#141414] border-4 border-black rounded-lg w-[500px] max-w-full text-white shadow-2xl relative">
        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-3 text-gray-600 animate-pulse">Sender e-post...</p>
            </div>
          </div>
        ) : (
          <>
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-300 hover:text-white"
            >
              <X />
            </button>

            {/* Body */}
            <div className="p-6 space-y-4">
              <p className="text-lg">Invite participants to your meeting by email</p>

              {/* Recipients */}
              <div>
                <label className="block text-sm mb-1">Recipients</label>
                <input
                  type="text"
                  placeholder="Add email(s)"
                  className="w-full rounded-md px-3 py-2 bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recipients}
                  onChange={(e) => setRecipients(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm mb-1">Navn(s)</label>
                <input
                  type="text"
                  placeholder="Add navn(s)"
                  className="w-full rounded-md px-3 py-2 bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={names}
                  onChange={(e) => setNames(e.target.value)}
                />
              </div>

              {/* Message */}
              <div>
                <textarea
                  placeholder="Add a custom message"
                  rows={5}
                  className="w-full rounded-md px-3 py-2 bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>

              {/* Buttons */}
              <div className="flex justify-between items-center mt-3">
                {/* Copy Button with Tooltip */}
                <div className="relative group">
                  {/* <button
                    onClick={handleCopy}
                    className="flex items-center gap-2 text-white hover:text-blue-400"
                    style={{ background: "none", border: "none" }}
                  >
                    Copy link
                    <Copy />
                  </button> */}
                  <span className="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-xs text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                    {tooltipText}
                  </span>
                </div>

                {/* Send Button */}
                <button
                  onClick={handleSend}
                  className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md text-white transition"
                >
                  Send
                  <SendHorizontal />
                </button>
              </div>
            </div>
          </>
        )}

      </div>
    </div>
  );
}
